var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationOffIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24x24/On Light/Cross"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7449 33.0771L47.7622 21.0599C48.6409 20.1812 50.0655 20.1812 50.9442 21.0599C51.8228 21.9386 51.8228 23.3632 50.9442 24.2419L38.9269 36.2591L50.9409 48.2731C51.8196 49.1518 51.8196 50.5764 50.9409 51.4551C50.0622 52.3338 48.6376 52.3338 47.7589 51.4551L35.7449 39.4411L23.731 51.4551C22.8523 52.3338 21.4277 52.3338 20.549 51.4551C19.6703 50.5764 19.6703 49.1518 20.549 48.2731L32.563 36.2591L20.5457 24.2419C19.667 23.3632 19.667 21.9386 20.5457 21.0599C21.4244 20.1812 22.849 20.1812 23.7277 21.0599L35.7449 33.0771Z",
    fill: "#E3E4F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOffIcon);
export default __webpack_public_path__ + "static/media/notification-off-icon.73bb62f2c526057d369822b3cb5a2b0b.svg";
export { ForwardRef as ReactComponent };